<div class="seperator"></div>
<div class="title" mat-dialog-title>Select Network ID</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You can select multiple Networks from the below</div>
        <mat-form-field appearance="outline" class="form-field">
            <mat-label>Networks</mat-label>
            <mat-select multiple [formControl]="gamNetworkIds">
                <mat-option *ngFor="let network of data.networks" [value]="network.id + ''">
                    {{network.id + ' - ' + network.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()">
            Connect Data Source
        </button>
    </div>
</div>